interface ExtendedTagMessage {
  period: number
  extendedDuration?: number
  currentPolicy: number
  maxPolicies?: number
}

function getExtendedTagMessage({
  period,
  extendedDuration = period,
  currentPolicy,
  maxPolicies = currentPolicy
}: ExtendedTagMessage) {
  if (extendedDuration && currentPolicy > 1) {
    if (extendedDuration !== period) {
      return `${period} + ${extendedDuration}`
    }
    return `${maxPolicies > 1 ? maxPolicies + 'x' : ''}${period}`
  }

  return period
}

export default getExtendedTagMessage
